import {useState} from "react";
import Donut2 from "../Dashboard/acara/dashboardChart/Donut2";
import SalesChart from "../Dashboard/acara/dashboardChart/Sales";
import ImageComponent from "../shared/ImageComponent";
import {buildChatImageUrl, buildImageUrl} from "../../../utils/imageUrlBuilder";
import NoImage from "../../../images/NoImage.jpg";
import videoImage from "../../../images/thumbVideo.png";
import LightGallery from "lightgallery/react";
import lgVideo from "lightgallery/plugins/video";
import lgZoom from "lightgallery/plugins/zoom";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-video.css"; // The video plugin's CSS
import "lightgallery/css/lg-zoom.css";

const InterventionReport = ({className, files, intervention}) => {
  return (
    // <div className="col-xl-12 col-sm-6">
    //   <div class="card">
    //     <div class="card-header border-0 pb-0">
    //       <h4 class="fs-20 text-black">Pièces jointes</h4>
    //     </div>

    //     <div class="card-body pt-3 flex flex-col gap-4">

    //     </div>
    //   </div>
    // </div>
    <div className="w-full flex flex-col gap-4 justify-start items-start h-fit bg-white rounded-xl p-4">
      <div className="text-[#19295C] font-semibold text-lg mt-2 ">Rapport</div>
      <div className="break-all">{intervention?.report}</div>
      {!files || !files.length ? null : (
        <>
          <LightGallery
            plugins={[lgVideo, lgZoom]}
            settings={{
              videojs: true,
              videojsTheme: "city",
              controls: true,
            }}
            elementClassNames=" grid grid-cols-3 md:grid-cols-4  lg:grid-cols-5 gap-3
          "
          >
            {files.map((image, index) => {
              return image.format === "VIDEO" ? (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a
                  key={image.id}
                  data-video={`{"source": [{"src": "${buildChatImageUrl(
                    image?.path,
                  )}", "type": "video/mp4"}], "attributes": {"controls": true}}`}
                  data-sub-html="<h4>Video Preview</h4>"
                  className=" rounded-xl lg:rounded-lg border border-solid border-[#e2e2e2] min-w-14 w-full aspect-square object-cover cursor-pointer "
                >
                  <img
                    className=" rounded-xl lg:rounded-lg border border-solid border-[#e2e2e2] min-w-14 w-full aspect-square object-cover cursor-pointer"
                    src={videoImage}
                    alt="video thumbnail"
                  />
                </a>
              ) : (
                <ImageComponent
                  key={image?.id}
                  src={buildImageUrl(image?.path)}
                  className="rounded-xl lg:rounded-lg border border-solid border-[#e2e2e2] min-w-14 w-full aspect-square  object-cover cursor-pointer"
                  alt="annonce"
                  fallback={
                    <img
                      alt="annonce"
                      src={NoImage}
                      className="rounded-xl lg:rounded-lg border border-solid border-[#e2e2e2] min-w-14 w-full aspect-square  object-cover cursor-pointer"
                    />
                  }
                />
              );
            })}
          </LightGallery>
        </>
      )}
    </div>
  );
};
export default InterventionReport;
